import { Component, EventEmitter, Output } from '@angular/core';
import { LendioAngularMaterialThemeService } from '../lendio-angular-material-theme.service';

@Component({
  selector: 'app-lendio-angular-material-theme-toggle',
  templateUrl: './lendio-angular-material-theme-toggle.component.html',
  styleUrls: ['./lendio-angular-material-theme-toggle.component.scss']
})
export class LendioAngularMaterialThemeToggleComponent {

  constructor(private _themeService: LendioAngularMaterialThemeService) {
  }
  @Output() themeToggle: EventEmitter<any> = new EventEmitter();

  handleClick() {
    this._themeService.toggle();
    this.themeToggle.emit();
  }
}
